<mat-drawer-container class="flex-auto h-full bg-card dark:bg-transparent" (backdropClick)="onBackdropClicked()"
    *transloco="let t">

    <!-- Drawer -->
    <mat-drawer class="w-full sm:w-100 dark:bg-gray-900" [mode]="drawerMode" [opened]="openDrawer" [position]="'end'"
        [disableClose]="true" #matDrawer>
        <div *ngIf="item" class="flex flex-col flex-auto p-6 md:p-8">

            <!-- Close button -->
            <div class="flex items-center justify-end">
                <button mat-icon-button (click)="openDrawer = false">
                    <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
            </div>

            <!-- Preview -->
            <div class="aspect-w-9 aspect-h-6 mt-8">
                <div class="flex items-center justify-center border rounded-lg bg-gray-50 dark:bg-card">
                    <ng-container *ngIf="item.type === 'folder'">
                        <mat-icon class="icon-size-14 text-hint" [svgIcon]="'iconsmind:folder'"></mat-icon>
                    </ng-container>
                    <ng-container *ngIf="item.type !== 'folder'">
                        <mat-icon class="icon-size-14 text-hint" [svgIcon]="'iconsmind:file'"></mat-icon>
                    </ng-container>
                </div>
            </div>

            <!-- Name & Type -->
            <div class="flex flex-col items-start mt-8">
                <div class="text-xl font-medium">{{item.filename}}</div>
                <div class="mt-1 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                    [ngClass]="getTypeColor(item.type)">
                    {{getDisplayType(item.type)}}
                </div>
            </div>

            <!-- Information -->
            <div class="text-lg font-medium mt-8">{{t("Information")}}</div>
            <div class="flex flex-col mt-4 border-t border-b divide-y font-medium">
                <div class="flex items-center justify-between py-3">
                    <div class="text-secondary">{{t("Created By")}}</div>
                    <div>{{item.createdBy || ''}}</div>
                </div>
                <div class="flex items-center justify-between py-3">
                    <div class="text-secondary">{{t("Created At")}}</div>
                    <div>{{item.createdAt || ''}}</div>
                </div>
                <div class="flex items-center justify-between py-3">
                    <div class="text-secondary">{{t("Modified At")}}</div>
                    <div>{{item.modifiedAt || ''}}</div>
                </div>
                <div class="flex items-center justify-between py-3">
                    <div class="text-secondary">{{t("Size")}}</div>
                    <div>{{item.size}}</div>
                </div>
                <ng-container *ngIf="item.contents">
                    <div class="flex items-center justify-between py-3">
                        <div class="text-secondary">{{t("Contents")}}</div>
                        <div>{{item.contents}}</div>
                    </div>
                </ng-container>
            </div>

            <!-- Description -->
            <div class="flex items-center justify-between mt-8">
                <div class="text-lg font-medium">{{t("Description")}}</div>
                <!-- <button mat-icon-button>
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                    </button> -->
            </div>
            <div class="flex mt-2 border-t">
                <div class="py-3">
                    <ng-container *ngIf="item.description">
                        <div>{{item.description}}</div>
                    </ng-container>
                    <ng-container *ngIf="!item.description">
                        <div class="italic text-secondary">{{t("Click here to add a description")}}</div>
                    </ng-container>
                </div>
            </div>

            <!-- Actions -->
            <div class="grid grid-cols-2 gap-4 w-full mt-8">
                <a (click)="downloadFile(item?.filename)">
                    <button class="flex-auto" mat-flat-button [color]="'primary'">
                        {{t("Download")}}
                    </button>
                </a>
                <button *ngIf="checkDesignation() && !isViewMode()" class="flex-auto" mat-stroked-button
                    (click)="deleteStateSelector(item.id)">
                    {{t("Delete")}}
                </button>
            </div>

        </div>

    </mat-drawer>

    <mat-drawer-content class="flex flex-col bg-gray-100 dark:bg-transparent">

        <!-- Main -->
        <div class="flex flex-col flex-auto">

            <!-- Header -->
            <div *ngIf="upload"
                class="flex flex-col sm:flex-row items-start sm:items-center sm:justify-between pb-3 md:px-8 border-b bg-card dark:bg-transparent">
                <!-- Title -->
                <div>
                    <!-- <div class="text-4xl font-extrabold tracking-tight leading-none">{{t("File Manager")}}</div> -->
                    <div class="flex items-center mt-0.5 font-medium text-lg text-secondary">
                        <!-- Breadcrumbs -->
                        <ng-container class="mt-6">
                            <div class="flex items-center space-x-2">
                                <ng-container *ngIf="!insideFolder">
                                    <a class="text-primary cursor-pointer" (click)="openHome()">{{t("Home")}}
                                    </a>
                                    <div class="">/&nbsp;&nbsp;&nbsp;</div>
                                </ng-container>
                                <ng-container *ngIf="insideFolder">
                                    <button mat-mini-fab color="primary" (click)="openHome()" style="box-shadow: none;">
                                        <mat-icon class="text-white">arrow_back</mat-icon>
                                    </button>
                                    <div class="ml-2">/ {{folderName}}</div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <!-- Actions -->
                <div class="mt-4 sm:mt-0 flex flex-col items-end" *ngIf="!isViewMode()">
                    <div class="font-bold">{{t("Maximum upload file size")}}: 10MB</div>
                    <!-- Upload button -->
                    <button (click)="csvInput.click()" mat-flat-button [color]="'primary'">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2 mr-1">{{t("Upload file")}}</span>
                    </button>
                    <input #csvInput hidden="true" type="file" multiple onclick="this.value=null"
                        (change)="uploadFile($event)" />
                </div>
            </div>

            <!-- Items list -->
            <ng-container *ngIf="items && (items.folders.length > 0 || items.files.length > 0); else noItems">
                <div class="p-6 md:p-8 space-y-8" appDrag (files)="filesDropped($event)">
                    <div id="dropfiles-title"
                        class="text-4xl font-extrabold tracking-tight leading-none dropfiles-div ">{{t("Drop Files
                        Here")}}!</div>
                    <!-- Folders -->
                    <ng-container *ngIf="items.folders.length > 0">
                        <div>
                            <div class="font-medium">{{t("Folders")}}</div>
                            <div class="flex flex-wrap -m-2 mt-2">
                                <ng-container *ngFor="let folder of items.folders; trackBy:trackByFn">
                                    <div class="relative w-40 h-40 m-2 p-4 shadow rounded-2xl bg-card">
                                        <a class="absolute z-20 top-1.5 right-1.5 w-8 h-8 min-h-8"
                                            (click)="selectFolder(folder.id)" mat-icon-button>
                                            <mat-icon class="icon-size-5"
                                                [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
                                        </a>
                                        <a class="z-10 absolute inset-0 flex flex-col p-4 cursor-pointer"
                                            (click)="openFolder(folder.id)">
                                            <div class="aspect-w-9 aspect-h-6">
                                                <div class="flex items-center justify-center">
                                                    <!-- Icon -->
                                                    <mat-icon class="icon-size-14 text-hint"
                                                        [svgIcon]="'iconsmind:folder'"></mat-icon>
                                                </div>
                                            </div>
                                            <div
                                                class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
                                                <div class="truncate" [matTooltip]="folder.name">{{folder.name}}</div>
                                                <ng-container *ngIf="folder.contents">
                                                    <div class="text-secondary truncate">{{folder.contents}}</div>
                                                </ng-container>
                                            </div>
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Files -->
                    <ng-container *ngIf="items.files.length > 0">
                        <div>
                            <div class="font-medium">Files</div>
                            <div class="flex flex-wrap -m-2 mt-2">
                                <ng-container *ngFor="let file of items.files; trackBy:trackByFn">
                                    <div class="link-container">
                                        <a class="flex flex-col w-40 h-40 m-2 p-4 shadow rounded-2xl cursor-pointer bg-card link"
                                            (click)="downloadFile(file?.filename)">

                                            <div class="aspect-w-9 aspect-h-6">
                                                <div class="flex items-center justify-center">
                                                    <!-- Icons -->
                                                    <div class="relative">
                                                        <mat-icon class="icon-size-14 text-hint"
                                                            [svgIcon]="'iconsmind:file'"></mat-icon>
                                                        <div class="download-indicator">
                                                            <mat-icon
                                                                [svgIcon]="'heroicons_outline:document-download'"></mat-icon>
                                                        </div>
                                                        <div class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                                                            [ngClass]="getTypeColor(file.type)">
                                                            {{getDisplayType(file.type)}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
                                                <div class="truncate" [matTooltip]="file.filename">{{file.filename}}
                                                </div>
                                                <ng-container *ngIf="file.contents">
                                                    <div class="text-secondary truncate">{{file.contents}}</div>
                                                </ng-container>
                                            </div>
                                        </a>
                                        <div *ngIf="checkDesignation() && !isViewMode()" class="delete-icon">
                                            <mat-icon title="Delete" color="warn"
                                                (click)="deleteStateSelector(file.id)">delete</mat-icon>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <div>
                <!-- No items template -->
                <ng-template #noItems>
                    <div appDrag (files)="filesDropped($event)"
                        class="py-12 flex flex-auto flex-col items-center justify-center">
                        <div id="dropfiles-title"
                            class="text-4xl font-extrabold tracking-tight leading-none dropfiles-div-nofile ">{{t("Drop
                            Files Here")}}!</div>
                        <mat-icon class="icon-size-20" [svgIcon]="'iconsmind:file_hide'"></mat-icon>
                        <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">{{t("There are no
                            items")}}!</div>
                    </div>
                </ng-template>
            </div>

        </div>

    </mat-drawer-content>

</mat-drawer-container>